import { MenuItem, Select } from '@material-ui/core'
import { mdiContentSave } from '@mdi/js'
import React, { useCallback, useEffect }  from 'react'
import { useDispatch } from 'react-redux'
import Section, { SectionBox, SectionOption } from '../../../../components/Section'
import SnackbarAlert from '../../../../components/SnackbarAlert'
import createAlert from '../../../../scripts/alert/createAlert'
import { useAppSelector } from '../../../../store/hooks'
import { setAlert } from '../../../../store/reducers/alert/alertReducer'
import { DOMAIN } from '../../../../var_env.'
import TableListarArquivos from './components/TableListarComponents'
import { setLaboratorio } from './Reducer/UploadArquivoReducer'
import fileExist from './scripts/fileExist'
import getFiles from './scripts/getFiles'
import remove from './scripts/remove'
import saveFile from './scripts/saveFile'
import { uploadArquivo } from './tipes'

const ImportacaoAnalise: React.FC = () => {

    const { userData } = useAppSelector(state => state.auth)
    
    const dispatch = useDispatch()

    const {lista , requestRemove, requestGetArquivo, laboratorioTeceiro} = useAppSelector(state => state.UploadArquivoReducer)
    const [file, setFile] = React.useState<any>();
    
    const handleFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentFile = e.target.files
        if (!!currentFile) setFile(currentFile[0])
    }
 
    const handleEnviarArquivo = useCallback(async (arquivo: any) => {
        (async() => {
            const dados ={
                filename: arquivo?.name,
                size: `${arquivo?.size}`,
                idUsuario:  userData!.id,
                conteudo: "Importacao_analise_amostra"
            }
            let arquivoExiste =  await fileExist(dispatch, arquivo?.name)

            if(arquivoExiste){
                dispatch(setAlert(createAlert('error', 'o arquivo ja foi cadastrado')))
            }else{
                let arquivoSalvo : uploadArquivo|undefined  =  await saveFile(dispatch,dados)
                const formData = new FormData()

                formData.append('analise', file)
                formData.append('idUsuario', userData!.id.toString())
                formData.append('idArquivoOrigem', `${arquivoSalvo?.id}`)
                formData.append('Laboratorio', `${laboratorioTeceiro}`)
                const endpoint = `${DOMAIN}/ImportacaoAnalise/upload`
                const response: any = await fetch(endpoint,{method:'POST',body:formData })
                const resposta:{sucesso:boolean, msg:string} = await response.json()
                if(resposta.sucesso) dispatch(setAlert(createAlert('success', 'Dados dos arquivo foram salvos')))
                else dispatch(setAlert(createAlert('error', resposta.msg)))
            }
        })()
    },[file, userData, dispatch, laboratorioTeceiro])
        
    const handleApagarFile = useCallback( async (idDelete: number|undefined) => {
        if(window.confirm("Apagando esse arquivo Apagara todos os dados referente a ele! Tem certeza?")){
            const dados = {
                id: idDelete,
                idUsuario: userData!.id
            }
            remove(dispatch, dados)
        }
    },[userData, dispatch])

    useEffect(() => {
        getFiles(dispatch)
    }, [requestGetArquivo,requestRemove ,dispatch])

    return(
        <>
            <Section name = "Arquivos">
                <SectionBox 
                    title='Arquivos com amostras de análises' 
                    padding = {false}
                    right={
                        <>
                        	<Select id="filterAtivo" value={laboratorioTeceiro} onChange={e => dispatch(setLaboratorio(e.target.value as any))}>
                                <MenuItem value={1}>Opersan</MenuItem>
                                <MenuItem value={2}>Aqualab</MenuItem>
                            </Select>
                            <input id="fileInput" type="file" style={{ display: 'none' }} accept=".xls" name="analise" onChange={(e) => handleFile(e)} required />
                            <label htmlFor="fileInput" className={`btn default`}>{`${file ? file.name : 'Carregar excel'}`}</label>
                            <SectionOption icon = {mdiContentSave} tooltip = "Salvar" onClick = {() => handleEnviarArquivo(file)} />
                        </>
                    }
                > 
                    <TableListarArquivos  lista={lista} handleApagarFile={handleApagarFile}/>
                </SectionBox>
            </Section>
            <SnackbarAlert />
        </>
    
    )
}

export default ImportacaoAnalise

